// utils/getPathPrefix.ts
export const getPathPrefix = (path: string) => {
  const branchPath = process.env.NEXT_BRANCH_PATH || "";
  return `${branchPath}${path}`;
};
